import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  $sentimeter_red: "#ea0000",
  background: {
    backgroundColor: "$sentimeter_red",
  },
  card: {
    backgroundColor: "$sentimeter_red",
  },
  container: {
    alignItems: "center",
  },
  tagLine: {
    fontSize: "$h4",
    color: "white",
    textAlign: "center",
    width: "60vmin",
    marginBottom: "5vh",
  },
  "@media (max-width: 700)": {
    tagLine: {
      width: "80vmin",
    },
  },
  logo: {
    width: "$width_logo",
    height: "$height_logo",
  },
  logout: {
    position: "absolute",
    top: "3vh",
    right: "6vw",
  },
  logoutText: {
    fontSize: "$h5",
    color: "white",
  },
  helpArea: {
    flexDirection: "row",
    position: "absolute",
    alignSelf: "center",
    bottom: 0,
    elevation: 5,
  },
  helpText: {
    fontSize: "$h5",
    color: "white",
    padding: 3,
  },
  helpLinkText: {
    fontSize: "$h5",
    color: "white",
    textDecorationLine: "underline",
  },
});
